import React, { memo } from 'react';
import withErrorBoundary from './withErrorBoundary';

export default  (Component) => memo(withErrorBoundary(Component));
